import { getWeb3 } from '../../config/web3';

export const FETCH_WEB3 = 'SET_FETCH_WEB3';
export const SET_MY_WALLET_ADDRESS = 'SET_MY_WALLET_ADDRESS';
export const SET_STATUS = 'SET_STATUS';

export const fetchWeb3 = () => async dispatch =>
  new Promise((resolve, reject) => {
    const web3 = getWeb3();

    dispatch({
      type: FETCH_WEB3,
      payload: web3
    });

    resolve(web3);
  });

export const setMyWalletAddress = value => ({
  type: SET_MY_WALLET_ADDRESS,
  payload: value
});

export const setStatus = value => ({
  type: SET_STATUS,
  payload: value
});



// WEBPACK FOOTER //
// ./src/redux/actions/web3Actions.js